export default __webpack_public_path__ + "locales/sl/ResetApplicationDialog.json?hash=4b46ec2f8c9cd274668ef0221fb28346";